import { KeyboardEvent, MouseEvent } from 'react';
import { MdClose } from 'react-icons/md';
import { EMPTY_OPTION, KEYBOARD } from 'commons';
import * as S from './styles';
import { useSelect } from '../../hooks';

export function ClearButton() {
  const { option, setOption, tagList, setTagList, setInputText } = useSelect();

  const hideButton = !Boolean(option.value) && !Boolean(tagList.length);

  if (hideButton) return null;

  function clearAllOptions() {
    setOption(EMPTY_OPTION);
    setTagList([]);
    setInputText('');
  }

  return (
    <S.Main
      onClick={(event: MouseEvent) => {
        event.stopPropagation();

        clearAllOptions();
      }}
      onKeyDown={(event: KeyboardEvent) => {
        event.stopPropagation();

        const { key } = event;

        if (key === KEYBOARD.enter) {
          clearAllOptions();
        }
      }}
      tabIndex={0}
      aria-label="button"
    >
      <MdClose />
    </S.Main>
  );
}
